export default {
  hello: "Ready to start a new bomify projecct :D (FR)",
  developed_by: "Développé par <a href='https://bambus-software.ch' target='_blank' noopener noreferrer>Bambus Software</a> et <a href='https://polygon-software.ch/' target='_blank' noopener noreferrer>PolygonSoftware</a>",
};
